var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "genericReleaseModal",
        "content-class": "generic-release-modal",
        size: "lg",
        "hide-footer": "",
        "hide-header-close": "",
        centered: "",
      },
      on: {
        show: function ($event) {
          _vm.selected = false
        },
        hide: _vm.handleClose,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c(
                "div",
                { staticClass: "grm-header d-flex align-items-center w-100" },
                [
                  _c("div", { staticClass: "grm-header-icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: {
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "#4db8ff",
                            "stroke-width": "1.5",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2z",
                            stroke: "#4db8ff",
                            "stroke-width": "1.5",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M4.93 4.93a16 16 0 0 1 14.14 0M4.93 19.07a16 16 0 0 0 14.14 0",
                            stroke: "#4db8ff",
                            "stroke-width": "1.5",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "grm-header-text" }, [
                    _c("h5", { staticClass: "grm-title mb-0" }, [
                      _vm._v("Select a Release"),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "grm-subtitle mb-0" }, [
                      _vm._v("Choose a dataset to explore on the map"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "grm-header-badge ml-auto" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.releases.length) +
                        " release" +
                        _vm._s(_vm.releases.length !== 1 ? "s" : "") +
                        " available\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("fa", {
                    staticClass: "grm-header-close",
                    attrs: { icon: ["fas", "times"] },
                    on: {
                      click: function ($event) {
                        return close()
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "button",
                {
                  staticClass: "grm-close-btn",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.hide("genericReleaseModal")
                    },
                  },
                },
                [_vm._v("\n      Close\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "grm-body", attrs: { fluid: "" } },
        [
          _vm.releases.length === 0
            ? _c(
                "b-row",
                { staticClass: "justify-content-center" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "text-center grm-empty",
                      attrs: { cols: "12" },
                    },
                    [
                      _c("div", { staticClass: "grm-empty-icon" }, [
                        _vm._v("◎"),
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v("No releases available")]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "grm-grid" },
            _vm._l(_vm.releases, function (release) {
              return _c(
                "b-col",
                {
                  key: release.id,
                  staticClass: "grm-card-col mb-3",
                  attrs: { cols: "12", sm: "6" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "grm-card",
                      on: {
                        click: function ($event) {
                          return _vm.datasetSelected(release)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "grm-map-preview" }, [
                        _c("div", { staticClass: "grm-map-glow" }),
                        _vm._v(" "),
                        _vm.getRegionImage(release.extent_description)
                          ? _c("img", {
                              staticClass: "grm-map-img",
                              attrs: {
                                src: _vm.getRegionImage(
                                  release.extent_description
                                ),
                                alt: release.extent_description,
                              },
                            })
                          : _c("div", { staticClass: "grm-map-placeholder" }, [
                              _c(
                                "svg",
                                {
                                  staticClass: "grm-globe-icon",
                                  attrs: {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("circle", {
                                    attrs: {
                                      cx: "12",
                                      cy: "12",
                                      r: "10",
                                      stroke: "#4db8ff",
                                      "stroke-width": "1.5",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2z",
                                      stroke: "#4db8ff",
                                      "stroke-width": "1.5",
                                    },
                                  }),
                                ]
                              ),
                            ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "grm-card-info" }, [
                        _c("div", { staticClass: "grm-region-name" }, [
                          _vm._v(_vm._s(release.extent_description)),
                        ]),
                        _vm._v(" "),
                        release.release_label
                          ? _c("div", { staticClass: "grm-release-label" }, [
                              _vm._v(_vm._s(release.release_label)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.wclFlag
                          ? _c("div", { staticClass: "grm-release-date" }, [
                              _c("span", { staticClass: "grm-date-dot" }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.formatDate(release.release_date)) +
                                  "\n            "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "grm-card-action" }, [
                        _c("span", { staticClass: "grm-action-label" }, [
                          _vm._v("Select"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "grm-action-arrow",
                            attrs: { viewBox: "0 0 16 16", fill: "none" },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M3 8h10M9 4l4 4-4 4",
                                stroke: "currentColor",
                                "stroke-width": "1.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "grm-card-shine" }),
                    ]
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }